import { Button, CircularProgress } from '@mui/material';

export function ReviewerAssignmentButtons({
  onCancel,
  onSubmit,
  onReassign,
  showReassign,
  disabled,
  posting,
}: {
  onCancel: () => void;
  onSubmit: () => void;
  onReassign: () => void;
  showReassign: boolean;
  disabled: boolean;
  posting: boolean;
}) {
  return (
    <>
      <Button onClick={onCancel}>Cancel</Button>

      {showReassign ? (
        <Button variant='primary' disabled={disabled || posting} onClick={onReassign}>
          {posting ? (
            <>
              Submitting…
              <CircularProgress size={16} sx={{ ml: 1 }} />
            </>
          ) : (
            'Re-assign'
          )}
        </Button>
      ) : (
        <Button variant='primary' disabled={disabled || posting} onClick={onSubmit}>
          {posting ? (
            <>
              Submitting…
              <CircularProgress size={16} sx={{ ml: 1 }} />
            </>
          ) : (
            'Submit Assignment'
          )}
        </Button>
      )}
    </>
  );
}
